import { render, staticRenderFns } from "./ApplicationTemplate.vue?vue&type=template&id=56163fd5&scoped=true&"
import script from "./ApplicationTemplate.vue?vue&type=script&lang=js&"
export * from "./ApplicationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56163fd5",
  null
  
)

export default component.exports